import {
  Logo,
  Modal,
} from 'anf-core-react';
import PropTypes from 'prop-types';
import React from 'react';
import { useSearchParam } from 'react-use';
import useTranslatedText from '../../hooks/useTranslatedText';

import $window from '../../tools/window';
import SearchBox from '../SearchBox/SearchBox';
import style from '../SearchBox/searchWrapper.module.scss';

// Need this for a DS bug where the onOpen event is called even when the toaster is closed
const handleModalOpen = () => {
  if ($window.digitalData) {
    $window.digitalData.trigger('mfe-search-toaster-opened');
  }
};

const SearchFlyout = ({
  brand = '',
  handleModalClose = () => { },
  isSearchToasterOpen = false,
  searchFlyoutRecs = false,
  searchUrl = '',
}) => {
  const betaFlagGroup = useSearchParam('group');

  const closeMenu = useTranslatedText('closeMenu', { fallback: 'Close' });

  return (
    <>
      <Modal
        closeButtonLabel={closeMenu?.value}
        id="exposed-search-toaster"
        isFullscreen
        isOpen={isSearchToasterOpen}
        onClose={handleModalClose}
        onOpen={handleModalOpen}
        variant="headerless"
      >
        <>
          <div className={`scope-1892 ${style.logoWrapper}`}>
            <Logo kind={brand === 'hol' ? 'hco' : brand} />
          </div>
          <SearchBox
            betaFlagGroup={betaFlagGroup}
            searchFlyoutRecs={searchFlyoutRecs}
            searchUrl={searchUrl}
          />
        </>
      </Modal>
    </>
  );
};

SearchFlyout.propTypes = {
  brand: PropTypes.string,
  isSearchToasterOpen: PropTypes.bool,
  handleModalClose: PropTypes.func,
  searchFlyoutRecs: PropTypes.bool,
  searchUrl: PropTypes.string,
};

export default SearchFlyout;
